var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"rounded":"xl"}},[_c('v-card-text',[_c('div',{staticClass:"title font-weight-bold d-flex justify-center pa-4",attrs:{"color":"text--primary"}},[_vm._v(_vm._s(_vm.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }